import { NgModule } from "@angular/core";
import { Ng1StateProxyProvider } from "@webapp/core/provider-upgrade/providers/ng1-state.proxy";
import { UiModule } from "@webapp/ui/ui.module";
import { CommonModule } from "@angular/common";
import { ConfirmStatusActionComponent } from "./components/confirm-status-action/confirm-status-action.component";
import { StatusActionComponent } from "./components/status-action/status-action.component";
import { TeamsFacade } from "./services/teams-facade.service";
import { TeamsApiService } from "./services/teams-api.service";
import { TeamsState } from "./services/teams-state.service";

@NgModule({
  declarations: [ConfirmStatusActionComponent, StatusActionComponent],
  imports: [UiModule, CommonModule],
  providers: [Ng1StateProxyProvider, TeamsFacade, TeamsApiService, TeamsState],
})
export class TeamsModule {}
